import { render, staticRenderFns } from "./ProjectCard.vue?vue&type=template&id=4b3f916e&scoped=true&"
import script from "./ProjectCard.vue?vue&type=script&lang=js&"
export * from "./ProjectCard.vue?vue&type=script&lang=js&"
import style0 from "./ProjectCard.vue?vue&type=style&index=0&id=4b3f916e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3f916e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/marcosalazar/Documents/HM/Timelapse/timelapse-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b3f916e')) {
      api.createRecord('4b3f916e', component.options)
    } else {
      api.reload('4b3f916e', component.options)
    }
    module.hot.accept("./ProjectCard.vue?vue&type=template&id=4b3f916e&scoped=true&", function () {
      api.rerender('4b3f916e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ProjectCard.vue"
export default component.exports